document.addEventListener("DOMContentLoaded", () => {
  const switchers = document.querySelectorAll("[data-locale-switcher]");

  switchers.forEach((switcher) => {
    const toggle = switcher.querySelector(".locale-switcher__toggle");

    toggle.addEventListener("click", (event) => {
      event.stopPropagation();
      const isOpen = switcher.classList.toggle("locale-switcher--open");
      toggle.setAttribute("aria-expanded", isOpen);
    });
  });

  document.addEventListener("click", () => {
    switchers.forEach((switcher) => {
      const toggle = switcher.querySelector(".locale-switcher__toggle");
      switcher.classList.remove("locale-switcher--open");
      toggle.setAttribute("aria-expanded", "false");
    });
  });

  document.querySelectorAll(".locale-switcher [name='locale_code']").forEach(btn => {
    btn.addEventListener("click", (e) => {
      e.preventDefault();
      const lang = btn.value;

      if (lang === "en") window.location.href = "/";
      if (lang === "de") window.location.href = "/de";
      if (lang === "nl") window.location.href = "/nl";
    });
  });
});
